(function () {
  'use strict';
  if (window.KWCartDrawer) return;

  var SECTION = 'kw-cart-drawer';
  var subs = { opened: [], loaded: [], updated: [] };
  var lastCart = null;

  window.igEvents = window.igEvents || [];

  function fire(list, cart) {
    for (var i = 0; i < list.length; i++) { try { list[i]({ cart: cart }); } catch (e) {} }
  }
  function winEvent(name, detail) {
    try { window.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); } catch (e) {}
  }

  var KWCartDrawer = /** @class */ (function (Base) {
    function El() { return Reflect.construct(Base, [], El); }
    El.prototype = Object.create(Base.prototype);
    El.prototype.constructor = El;

    El.prototype.connectedCallback = function () {
      var self = this;
      this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || this.getAttribute('data-root') || '/';
      if (this.root.slice(-1) !== '/') this.root += '/';
      this.queue = Promise.resolve();
      this.qtyTimers = {};
      this.isOpen = false;
      this.ppActive = false;
      this.insActive = false;
      this.insured = false;
      this.towelActive = false;
      this.lastFocus = null;

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var m = self.querySelector('[data-kwc-ppm].is-open');
        if (m) { m.classList.remove('is-open'); return; }
        if (self.isOpen) self.close();
      });
      document.addEventListener('cart:updated', this.onExternalUpdate.bind(this));

      if (this.getAttribute('data-pp-force') === 'true' || window.IG_PACKAGE_PROTECTION) this.activatePP();
      if (this.getAttribute('data-ins-force') === 'true' || window.IG_INSURANCE) this.activateIns();
      this.initTowel();
      this.initReserved();
      requestAnimationFrame(function () { self.classList.add('is-ready'); });
      fetch(this.root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { lastCart = c; fire(subs.loaded, c); winEvent('aftersell-upcart:public-events:cart-loaded', { cart: c }); })
        .catch(function () {});
    };
    El.prototype.open = function () {
      if (this.isOpen) return;
      this.isOpen = true;
      this.lastFocus = document.activeElement;
      this.classList.add('is-open');
      document.body.classList.add('kw-drawer-open', 'upcartPopupShow');
      this._sy = window.scrollY || document.documentElement.scrollTop || 0;
      var bs = document.body.style;
      bs.position = 'fixed'; bs.top = (-this._sy) + 'px'; bs.left = '0'; bs.right = '0'; bs.width = '100%';
      var panel = this.querySelector('.kwc-panel');
      if (panel) panel.focus({ preventScroll: true });
      window.igEvents.push({ event: 'cart_opened' });
      window.igEvents.push({ event: 'upcart_cart_opened' });
      fire(subs.opened, lastCart);
      winEvent('aftersell-upcart:public-events:cart-opened', { cart: lastCart });
      this.notifyUpsells();
      this.syncPP();
      this.syncIns();
      if (this.insActive) this.igPush('insurance_shown');
      this.towelShown();
    };

    El.prototype.close = function () {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.classList.remove('is-open');
      document.body.classList.remove('kw-drawer-open', 'upcartPopupShow');
      var bs = document.body.style;
      bs.position = ''; bs.top = ''; bs.left = ''; bs.right = ''; bs.width = '';
      window.scrollTo(0, this._sy || 0);
      if (this.lastFocus && this.lastFocus.focus) { try { this.lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    };

    El.prototype.notifyUpsells = function () {
      if (this.querySelector('[data-kwc-upsells]')) winEvent('aftersell-upcart:public-events:upsells:rendered', {});
    };
    El.prototype.onClick = function (e) {
      var t = e.target;
      var closer = t.closest('[data-kwc-close]');
      if (closer || t.classList.contains('kwc-overlay')) { e.preventDefault(); this.close(); return; }

      var minus = t.closest('[data-kwc-qty-minus]');
      var plus = t.closest('[data-kwc-qty-plus]');
      if (minus || plus) {
        var box = t.closest('[data-kwc-item]');
        var input = box.querySelector('[data-kwc-qty-input]');
        var q = Math.max(0, (parseInt(input.value, 10) || 0) + (plus ? 1 : -1));
        input.value = q;
        this.queueQty(box.getAttribute('data-key'), q, box);
        return;
      }

      var rm = t.closest('[data-kwc-remove]');
      if (rm) {
        var item = t.closest('[data-kwc-item]');
        item.classList.add('is-removing');
        this.mutate('cart/change.js', { id: item.getAttribute('data-key'), quantity: 0 });
        return;
      }

      var upsell = t.closest('[data-kwc-upsell-add]');
      if (upsell) { this.addUpsell(upsell); return; }

      var apply = t.closest('[data-kwc-code-apply]');
      if (apply) { this.applyDiscount(); return; }

      var rmCode = t.closest('[data-kwc-code-remove]');
      if (rmCode) { this.removeDiscount(rmCode.getAttribute('data-code')); return; }

      var ppInfo = t.closest('[data-kwc-pp-info]');
      if (ppInfo) {
        e.preventDefault();
        if (this.insActive) this.igPush('insurance_info_opened');
        this.togglePPModal(true);
        return;
      }

      var ppmClose = t.closest('[data-kwc-ppm-close]');
      if (ppmClose) { this.togglePPModal(false); return; }

      var checkout = t.closest('[data-kwc-checkout]');
      if (checkout) {
        if (this.insActive) { e.preventDefault(); this.insCheckout(checkout); return; }
        checkout.classList.add('is-loading'); return; // default nav proceeds
      }

      var ppBtn = t.closest('[data-kwc-pp-checkout]');
      if (ppBtn) { e.preventDefault(); this.protectedCheckout(ppBtn); return; }

      var ppPlain = t.closest('[data-kwc-pp-plain]');
      if (ppPlain) { e.preventDefault(); window.location.href = this.root + 'checkout'; return; }
    };

    El.prototype.onChange = function (e) {
      var t = e.target;
      if (t.matches('[data-kwc-ins-box]')) { this.toggleIns(t.checked); return; }
      if (t.matches('[data-kwc-towel-box]')) { this.toggleTowel(t); return; }
      if (t.matches('[data-kwc-qty-input]')) {
        var box = t.closest('[data-kwc-item]');
        var q = Math.max(0, parseInt(t.value, 10) || 0);
        t.value = q;
        this.queueQty(box.getAttribute('data-key'), q, box);
      }
      if (t.matches('.kwc-upsell-variant')) {
        var card = t.closest('.kwc-upsell-card');
        card.querySelector('[data-kwc-upsell-add]').setAttribute('data-variant-id', t.value);
      }
    };

    El.prototype.onKeydown = function (e) {
      if (e.key === 'Enter' && e.target.matches('[data-kwc-code-input]')) { e.preventDefault(); this.applyDiscount(); }
      if (e.key !== 'Tab' || !this.isOpen) return;
      var f = this.querySelectorAll('a[href],button:not([disabled]),input,select,[tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    El.prototype.queueQty = function (key, qty, box) {
      var self = this;
      clearTimeout(this.qtyTimers[key]);
      this.qtyTimers[key] = setTimeout(function () {
        if (qty === 0 && box) box.classList.add('is-removing');
        self.mutate('cart/change.js', { id: key, quantity: qty });
      }, 300);
    };

    El.prototype.mutate = function (endpoint, payload, opts) {
      var self = this;
      opts = opts || {};
      payload.sections = SECTION;
      this.queue = this.queue.then(function () {
        self.classList.add('is-busy');
        return fetch(self.root + endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (cart && cart.token) {           // full cart response (change/update/clear)
              lastCart = cart;
              self.renderFrom(cart.sections);
              self.dispatchCart(cart);
              if (opts.after) opts.after(cart);
            } else if (cart && cart.sections) { // add.js response
              self.renderFrom(cart.sections);
              return self.refreshCartJson(opts.after);
            }
          })
          .catch(function () { return self.refresh(); })
          .then(function () { self.classList.remove('is-busy'); });
      });
      return this.queue;
    };

    El.prototype.refreshCartJson = function (after) {
      var self = this;
      return fetch(this.root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { lastCart = c; self.dispatchCart(c); if (after) after(c); })
        .catch(function () {});
    };

    El.prototype.dispatchCart = function (cart) {
      fire(subs.updated, cart);
      winEvent('aftersell-upcart:public-events:cart-updated', { cart: cart });
      var d = Object.assign({}, cart, { __kw: true });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: d }));
    };
    El.prototype.renderFrom = function (sections) {
      var html = sections && sections[SECTION];
      if (!html) return this.refresh();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-drawer-inner]');
      var current = this.querySelector('[data-drawer-inner]');
      if (!fresh || !current) return;
      var body = this.querySelector('.kwc-body');
      var scroll = body ? body.scrollTop : 0;
      var focusKey = document.activeElement && document.activeElement.matches && document.activeElement.matches('[data-kwc-qty-input]')
        ? document.activeElement.closest('[data-kwc-item]').getAttribute('data-key') : null;
      current.replaceWith(fresh);
      var nb = this.querySelector('.kwc-body');
      if (nb) nb.scrollTop = scroll;
      if (focusKey) {
        var inp = this.querySelector('[data-kwc-item][data-key="' + focusKey + '"] [data-kwc-qty-input]');
        if (inp) inp.focus({ preventScroll: true });
      }
      this.notifyUpsells();
      this.syncPP();
      this.syncIns();
      this.initReserved();
      if (this.isOpen) this.towelShown();
    };
    El.prototype.initReserved = function () {
      var el = this.querySelector('[data-kwc-reserved]');
      if (this._resTimer) { clearInterval(this._resTimer); this._resTimer = null; }
      if (!el) return;
      var target = el.querySelector('[data-kwc-reserved-time]');
      if (!target) return;
      var mins = parseInt(el.getAttribute('data-minutes'), 10) || 15;
      var span = mins * 60000;
      var end = 0;
      try { end = parseInt(sessionStorage.getItem('kwcReserveEnd'), 10) || 0; } catch (e) {}
      var save = function (v) { try { sessionStorage.setItem('kwcReserveEnd', String(v)); } catch (e) {} };
      if (end <= Date.now()) { end = Date.now() + span; save(end); }
      var tick = function () {
        var left = end - Date.now();
        if (left <= 0) { end = Date.now() + span; save(end); left = span; }
        var s = Math.floor(left / 1000);
        var mm = Math.floor(s / 60);
        var ss = s % 60;
        target.textContent = mm + ':' + (ss < 10 ? '0' : '') + ss;
      };
      tick();
      this._resTimer = setInterval(tick, 1000);
    };

    El.prototype.refresh = function () {
      var self = this;
      return fetch(this.root + '?sections=' + SECTION, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (s) { self.renderFrom(s); })
        .catch(function () {});
    };

    El.prototype.onExternalUpdate = function (e) {
      var d = e.detail || {};
      if (d.__kw) return;
      if (d.token) lastCart = d;
      if (d.sections && d.sections[SECTION]) { this.renderFrom(d.sections); return; }
      if (window.__kwSections && window.__kwSections[SECTION]) {
        var s = window.__kwSections; window.__kwSections = null;
        this.renderFrom(s); return;
      }
      this.refresh();
    };
    El.prototype.addUpsell = function (btn) {
      btn.disabled = true;
      this.mutate('cart/add.js', { id: parseInt(btn.getAttribute('data-variant-id'), 10), quantity: 1 });
    };
    El.prototype.appliedCodes = function (cart) {
      var out = [];
      var list = (cart && cart.discount_codes) || [];
      for (var i = 0; i < list.length; i++) if (list[i].applicable) out.push(list[i].code);
      return out;
    };

    El.prototype.applyDiscount = function () {
      var self = this;
      var input = this.querySelector('[data-kwc-code-input]');
      var err = this.querySelector('[data-kwc-code-error]');
      var btn = this.querySelector('[data-kwc-code-apply]');
      if (!input || !input.value.trim()) return;
      var code = input.value.trim();
      if (err) err.hidden = true;
      if (btn) btn.disabled = true;
      var codes = this.appliedCodes(lastCart); codes.push(code);
      this.mutate('cart/update.js', { discount: codes.join(',') }, { after: function (cart) {
        var ok = (cart.discount_codes || []).some(function (d) {
          return d.applicable && d.code.toLowerCase() === code.toLowerCase();
        });
        if (!ok) {
          var keep = self.appliedCodes(cart).filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
          self.mutate('cart/update.js', { discount: keep.join(',') }).then(function () {
            var e2 = self.querySelector('[data-kwc-code-error]');
            var i2 = self.querySelector('[data-kwc-code-input]');
            var b2 = self.querySelector('[data-kwc-code-apply]');
            if (e2) e2.hidden = false;
            if (i2) i2.value = code;
            if (b2) b2.disabled = false;
          });
        }
      } });
    };

    El.prototype.removeDiscount = function (code) {
      var keep = this.appliedCodes(lastCart).filter(function (c) { return c.toLowerCase() !== String(code).toLowerCase(); });
      this.mutate('cart/update.js', { discount: keep.join(',') });
    };
    El.prototype.activatePP = function () { this.setPP(true); };

    // Two-way switch driven by the theme-level threshold gate (_igSyncProtection).
    // Hard-on paths (section setting, legacy IG global) always win so the old
    // force behavior and any legacy Intelligems injections keep working.
    El.prototype.setPP = function (on) {
      on = !!on;
      if (this.getAttribute('data-pp-force') === 'true' || window.IG_PACKAGE_PROTECTION) on = true;
      this.ppActive = on;
      this.classList.toggle('kwc-pp-active', on);
      // CSS already hides the insurance surface while kwc-pp-active is set,
      // so no insActive juggling is needed when PP toggles mid-session.
      this.syncPP();
    };

    El.prototype.togglePPModal = function (open) {
      var m = this.querySelector('[data-kwc-ppm]');
      if (m) m.classList.toggle('is-open', !!open);
    };

    // Runs on open and after every render. The freshly rendered markup carries Liquid's
    // decision (Theme settings > Package protection: country, cart band, protection already
    // in cart) as data-pp-on. JS adds the one input Liquid cannot see, traffic source
    // (window.kwPP.excluded from kw-forced-protection). setPP() from that script is only the
    // early answer between the cart:updated event and the re-render; this wins once markup lands.
    // Intelligems holdout flag; kwPP.holdout also carries the ?pph QA override (US snippet only)
    function holdoutOn() {
      return !!((window.kwPP && window.kwPP.holdout) || window.protectionHoldoutTest === true);
    }

    El.prototype.syncPP = function () {
      var pp = this.querySelector('[data-kwc-pp]');
      if (!pp) return;
      if (pp.hasAttribute('data-pp-on')) {
        var on = pp.getAttribute('data-pp-on') === 'true' && !(window.kwPP && window.kwPP.excluded);
        // holdout test group (any cart value): Liquid cannot see the Intelligems group, so drop the
        // forced surface here unless protection is already in the cart (then the fee stays visible)
        var secure = false;
        if (holdoutOn() && !this.insInCart()) { on = false; secure = true; }
        if (this.getAttribute('data-pp-force') === 'true' || window.IG_PACKAGE_PROTECTION) { on = true; secure = false; }
        this.ppActive = on;
        this.classList.toggle('kwc-pp-active', on);
        // holdout test group: same lock button, labelled SECURE CHECKOUT, adds nothing
        this.classList.toggle('kwc-sc-active', secure);
        // control never reaches this label code unless it was secure before (then it is put back)
        var lbl = this.querySelector('[data-kwc-co-label]');
        if (lbl && secure) {
          if (!lbl.hasAttribute('data-label-orig')) lbl.setAttribute('data-label-orig', lbl.textContent);
          // no total, same as the deployed PROTECTED CHECKOUT button; wording mirrors cart_drawer.pp_button per locale
          var SC = { en: 'Secure checkout', es: 'Pago seguro', fr: 'Paiement sécurisé' };
          var loc = ((window.Shopify && Shopify.locale) || document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
          lbl.textContent = SC[loc] || SC.en;
        } else if (lbl && lbl.hasAttribute('data-label-orig')) {
          lbl.textContent = lbl.getAttribute('data-label-orig');
          lbl.removeAttribute('data-label-orig');
        }
      }
      pp.hidden = !this.ppActive;
      // holdout test group never sees the optional insurance card either
      if (holdoutOn() && this.insActive) {
        this.insActive = false;
        this.classList.remove('kwc-ins-active');
      }
      var vid = this.getAttribute('data-pp-variant');
      var plain = this.querySelector('[data-kwc-pp-plain]');
      if (plain && vid && lastCart && lastCart.items) {
        var has = lastCart.items.some(function (it) { return String(it.variant_id) === String(vid); });
        plain.style.display = has ? 'none' : '';
      }
    };

    // Adds exactly one protection line, then navigates ONLY after Shopify has committed it.
    // Every write is keepalive so an in-flight request survives the page starting to unload,
    // and we confirm against a fresh /cart.js read before leaving. Waits for any pending
    // garment add (module-add-to-cart) to settle first, so it never reads a stale cart.
    El.prototype.protectedCheckout = function (btn) {
      var self = this;
      if (btn.classList.contains('is-loading')) return; // preloader running, ignore re-fires
      var vid = parseInt(this.getAttribute('data-pp-variant'), 10);
      btn.classList.add('is-loading');
      function go() { window.location.href = self.root + 'checkout'; }
      if (!vid) return go();
      var H = { 'Content-Type': 'application/json', Accept: 'application/json' };
      function read() { return fetch(self.root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
      function ensure() {
        return read().then(function (cart) {
          var line = (cart.items || []).find(function (it) { return it.variant_id === vid; });
          if (line && line.quantity === 1) return true;                 // already correct
          if (!line) return fetch(self.root + 'cart/add.js', { method: 'POST', headers: H, keepalive: true, body: JSON.stringify({ id: vid, quantity: 1 }) }).then(consume);
          return fetch(self.root + 'cart/change.js', { method: 'POST', headers: H, keepalive: true, body: JSON.stringify({ id: line.key, quantity: 1 }) }).then(consume);
        });
      }
      function consume(r) { return r.json().catch(function () { return null; }); } // drain body so the write is fully sent before unload
      // let a just-fired garment add land, then write protection, confirm, and only then leave
      self.queue.then(ensure).then(function () { return read(); }).then(function (cart) {
        var ok = (cart.items || []).some(function (it) { return it.variant_id === vid && it.quantity >= 1; });
        if (ok) return go();
        // one retry if the confirm read did not show it yet
        return ensure().then(read).then(go);
      }).catch(go); // fail-open to checkout
    };

    /* ---------- insurance checkbox test ---------- */

    El.prototype.igPush = function (name, extra) {
      var p = { event: name };
      if (extra) for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) p[k] = extra[k];
      try { (window.igEvents = window.igEvents || []).push(p); } catch (e) {}
      try { (window.dataLayer = window.dataLayer || []).push(p); } catch (e) {}
    };

    El.prototype.activateIns = function () {
      if (this.ppActive) return;           // forced protected checkout wins, never both surfaces
      if (holdoutOn()) return; // holdout test group: no insurance card
      this.insActive = true;
      this.classList.add('kwc-ins-active');
      this.syncIns();
    };

    El.prototype.insInCart = function () {
      var vid = parseInt(this.getAttribute('data-pp-variant'), 10);
      if (!vid || !lastCart || !lastCart.items) return false;
      return lastCart.items.some(function (it) { return it.variant_id === vid; });
    };

    // Runs on open and after every re-render, so it has to rebuild state from scratch.
    El.prototype.syncIns = function () {
      if (!this.insActive) return;
      var box = this.querySelector('[data-kwc-ins-box]');
      if (!box) return;
      var saved = null;
      try { saved = sessionStorage.getItem('kwcInsured'); } catch (e) {}
      // already paid for it wins, then the shopper's own last choice, else off
      this.insured = this.insInCart() || saved === '1';
      box.checked = this.insured;
      this.paintIns();
    };

    El.prototype.paintIns = function () {
      var on = this.insured;
      var card = this.querySelector('[data-kwc-ins-card]');
      if (card) card.classList.toggle('is-on', on);
      // The card sits in the product list, so the fee belongs in the subtotal.
      // That makes the drawer match what Shopify checkout will show line for line.
      var sub = this.querySelector('[data-kwc-sub]');
      if (sub) sub.textContent = sub.getAttribute(on ? 'data-sub-on' : 'data-sub-plain') || sub.textContent;
      var lbl = this.querySelector('[data-kwc-co-label]');
      if (lbl) lbl.textContent = lbl.getAttribute(on ? 'data-label-on' : 'data-label-plain') || lbl.textContent;
    };

    El.prototype.toggleIns = function (on) {
      this.insured = !!on;
      try { sessionStorage.setItem('kwcInsured', on ? '1' : '0'); } catch (e) {}
      this.paintIns();
      this.igPush(on ? 'insurance_checked' : 'insurance_unchecked');
      // if it is physically in the cart already and they opted out, take it back off now
      if (!on && this.insInCart()) this.insWrite(0, '');
    };

    // One cart write, carrying both the line and the attribution.
    // Toggling never touches the network, which keeps the drawer instant and stops
    // Shopify's Clear-Site-Data response headers spamming the console on every tap.
    // Attribution is a cart attribute, not a line-item property: properties change the
    // line key, which would stop the line merging with anything PDQ or PPU adds and
    // could put two protection lines on one order. The leading underscore hides it
    // from the customer at checkout. Never use two, that makes it unreadable.
    El.prototype.insWrite = function (qty, tag) {
      var vid = parseInt(this.getAttribute('data-pp-variant'), 10);
      var body = {};
      if (vid && qty !== null) {
        body.updates = {};
        body.updates[vid] = qty;                     // absolute quantity, cannot double-add
      }
      body.attributes = { _pp_source: tag || '' };
      return fetch(this.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        keepalive: true,                                 // survive the page unloading on checkout nav
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    };

    El.prototype.insCheckout = function (btn) {
      var self = this;
      if (btn.classList.contains('is-loading')) return;   // re-entry guard, not the disabled attr
      btn.classList.add('is-loading');
      this.igPush(this.insured ? 'insurance_checkout_insured' : 'insurance_checkout_plain');
      function go() { window.location.href = self.root + 'checkout'; }
      var vid = parseInt(this.getAttribute('data-pp-variant'), 10);
      var want = this.insured ? 1 : 0;
      var has = this.insInCart();
      var tag = this.insured ? 'cart_checkbox' : '';
      if (!vid || (want === 0 && !has)) return go();          // nothing to record, nothing to write
      var qty = (want === 1 && has) ? null : want;            // already correct? attribute only
      // wait for any pending garment add, write, drain the body, confirm, then leave
      this.queue
        .then(function () { return self.insWrite(qty, tag); })
        .then(function () {
          if (want === 0) return go();                          // opting out, nothing to confirm
          return fetch(self.root + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var ok = (cart.items || []).some(function (it) { return it.variant_id === vid && it.quantity >= 1; });
              return ok ? go() : self.insWrite(1, tag).then(go);
            });
        })
        .catch(function () { self.igPush('insurance_write_failed'); go(); });
    };

    /* ---------- towel cart add-on test ----------
       Gate order: section "On" > ?towel_test=1|0 (QA, per session) > window.IG_TOWEL_UPSELL.
       The inline stub in the section sets the flag if Intelligems runs before this file,
       initTowel() reads it on connect, igTowelUpsell(on) flips it live after that. */

    El.prototype.initTowel = function () {
      var qa = null;
      try {
        var m = /[?&]towel_test=([01])/.exec(window.location.search);
        if (m) sessionStorage.setItem('kwcTowelQA', m[1]);
        qa = sessionStorage.getItem('kwcTowelQA');
      } catch (e) {}
      if (qa === '1') window.IG_TOWEL_UPSELL = true;
      if (qa === '0') window.IG_TOWEL_UPSELL = false;
      this.setTowel(window.IG_TOWEL_UPSELL === true);
    };

    El.prototype.setTowel = function (on) {
      var mode = this.getAttribute('data-towel-mode');
      if (mode === 'on') on = true;
      if (mode === 'off') on = false;
      var was = this.towelActive;
      this.towelActive = !!on;
      this.classList.toggle('kwc-towel-active', this.towelActive);
      if (this.towelActive && !was && this.isOpen) this.towelShown();
    };

    // one impression per page view, only when the offer is actually on screen
    El.prototype.towelShown = function () {
      if (!this.towelActive || this._twSeen) return;
      if (!this.querySelector('[data-kwc-towel-offer]')) return;
      this._twSeen = true;
      this.igPush('towel_upsell_shown');
    };

    // One tap each way. Check adds 1 towel with a line property (keeps it the attached row
    // and gives it its own line, so a PDP towel never merges in); uncheck removes that line.
    El.prototype.toggleTowel = function (box) {
      // optimistic: the tick and border flip instantly, the row just locks until Shopify answers
      var row = box.closest('[data-kwc-towel]');
      if (row) { row.classList.add('is-busy'); row.classList.toggle('is-added', box.checked); }
      if (box.checked) {
        this.igPush('towel_upsell_added');
        this.mutate('cart/add.js', {
          items: [{ id: parseInt(box.getAttribute('data-variant-id'), 10), quantity: 1, properties: { _kw_src: 'cart_towel' } }]
        });
      } else {
        var key = row && row.getAttribute('data-key');
        this.igPush('towel_upsell_removed');
        if (key) this.mutate('cart/change.js', { id: key, quantity: 0 });
      }
    };

    return El;
  })(HTMLElement);

  customElements.define('kw-cart-drawer', KWCartDrawer);
  function el() { return document.getElementById('kw-cart-drawer'); }
  window.upcartOpenCart = function () { var d = el(); if (d) d.open(); };
  window.upcartCloseCart = function () { var d = el(); if (d) d.close(); };
  window.upcartRefreshCart = function () { var d = el(); if (d) d.refresh(); };
  window.upcartGetCart = function () { return lastCart; };
  window.upcartSubscribeCartOpened = function (fn) { subs.opened.push(fn); };
  window.upcartSubscribeCartLoaded = function (fn) { subs.loaded.push(fn); if (lastCart) { try { fn({ cart: lastCart }); } catch (e) {} } };
  window.upcartSubscribeCartUpdated = function (fn) { subs.updated.push(fn); };
  window.igPackageProtection = function () { var d = el(); if (d) d.activatePP(); };
  window.igInsurance = function () { var d = el(); if (d) d.activateIns(); };
  // holdout test hooks for markets without kw-forced-protection (it defines its own for US and wins)
  if (!window.enableProtectionHoldout) window.enableProtectionHoldout = function () { window.protectionHoldoutTest = true; var d = el(); if (d && d.syncPP) d.syncPP(); };
  if (!window.disableProtectionHoldout) window.disableProtectionHoldout = function () { window.protectionHoldoutTest = false; var d = el(); if (d && d.syncPP) d.syncPP(); };
  window.igTowelUpsell = function (on) { window.IG_TOWEL_UPSELL = on !== false; var d = el(); if (d && d.setTowel) d.setTowel(window.IG_TOWEL_UPSELL); };

  Object.defineProperty(window, 'KWCartDrawer', { get: el });
})();
